const vslData = {
  2: {
    videoPath: "public-videos/VSL 2 - DEFEATED (DOWN&OUT).mp4",
    stageLabel: "Stage #1 — “Drowning in the Ocean.”",
    bullets: [
      "Stuck in life",
      "Anxious, overwhelmed, or emotionally exhausted",
      "Unsure how to move forward",
      "Discouraged or close to giving up at times",
      "A deep desire for guidance, clarity, and support",
    ],
  },
  3: {
    videoPath: "public-videos/VSL 3 - BUILDING AWARNESS (NEW-IN-ROADS).mp4",
    stageLabel: "Stage #2 — “Head Barely Above the Water.”",
    bullets: [
      "Searching for greater clarity and direction in life",
      "Unsure of your identity or where you truly belong",
      "Frequently questioning yourself and your future",
      "In need of greater strength, stability, and confidence",
      "A deep desire for purpose, growth, and forward movement",
    ],
  },
  4: {
    videoPath: "public-videos/VSL 4 - SELF-GROWTH.mp4",
    stageLabel: 'Stage #3 — "Reaching the Island."',
    bullets: [
      "Hopeful about your future, but still searching for greater direction",
      "More confident in yourself, but struggling with consistency",
      "Growing in self-worth while still seeking deeper identity and clarity",
      "A desire to build greater strength, endurance, and momentum",
      "Like you are still trying to fully figure out your life and purpose",
    ],
  },
  5: {
    videoPath: "public-videos/VSL 5 - RELATIONSHIP STRUGGLES.mp4",
    stageLabel: "Stage #4 — “Leaving the Island in Your Lifeboat.”",
    bullets: [
      "A desire to develop healthier boundaries with people",
      "The need to find your confident voice and stand up for yourself",
      "A longing for healthier, more meaningful relationships",
      "A desire to better understand dating, emotional protection, and healthy connection",
      "A need to feel seen, respected, valued, and appreciated",
    ],
  },
  6: {
    videoPath: "public-videos/VSL 6 - FINDING & FULFILLING PURPOSE.mp4",
    stageLabel:
      "Stages #5 and #6 — “Reaching the Shoreline” and “Climbing the Mountain.”",
    bullets: [
      "Like your life is okay, but you still desire something greater or more meaningful",
      "Called toward deeper purpose, fulfillment, and direction in life",
      "A strong desire to pursue greater meaning and personal growth",
      "The need to better understand your unique purpose and potential",
      "A growing call toward leadership, discipline, impact, and helping others through your story and experiences",
    ],
  },
};

export default vslData;
